/* simms-rs: carousels, menus, add to cart in place; loads simms-rs-ask.js (enquiry pop-up). No dependencies.
   Carousel arrows (owner, 5 Oct 2026): move exactly one tile (first visible tile width + gap). Scroll snap is paused while the arrow moves the row, because iOS Safari snaps a programmatic scroll straight back to where it started. */
(function () {
  var me = document.currentScript;
  if (me && me.src) { var s = document.createElement('script'); s.src = me.src.replace('simms-rs.js', 'simms-rs-ask.js'); s.defer = true; document.head.appendChild(s); }
  function tileStep(t) {
    var kids = t.children, w = 0;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.classList && k.classList.contains('srs-revs__score')) continue;
      var r = k.getBoundingClientRect().width;
      if (r > 0) { w = r; break; }
    }
    var cs = getComputedStyle(t);
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
    return w > 0 ? w + gap : t.clientWidth * 0.8;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-srs-scroll]');
    if (b) {
      var t = document.getElementById(b.getAttribute('aria-controls'));
      if (t) {
        var dir = Number(b.getAttribute('data-srs-scroll')) || 1;
        var max = t.scrollWidth - t.clientWidth;
        var to = Math.max(0, Math.min(max, t.scrollLeft + dir * tileStep(t)));
        t.style.scrollSnapType = 'none';
        try { t.scrollTo({ left: to, behavior: 'smooth' }); } catch (err) { t.scrollLeft = to; }
        clearTimeout(t._srsSnapT);
        t._srsSnapT = setTimeout(function () { t.style.scrollSnapType = ''; }, 600);
      }
      return;
    }
    document.querySelectorAll('details[data-srs-close][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-srs-close][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });
  document.querySelectorAll('details[data-srs-mnav]').forEach(function (d) {
    d.addEventListener('toggle', function () { document.documentElement.classList.toggle('srs-lock', d.open); });
  });
  var mq = window.matchMedia('(min-width:821px)');
  function syncFooter() { document.querySelectorAll('.srs-f__col').forEach(function (d) { d.open = mq.matches; }); }
  syncFooter();
  if (mq.addEventListener) mq.addEventListener('change', syncFooter);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var live = document.createElement('div');
  live.className = 'srs-toast'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
  document.body.appendChild(live);
  var hideT, ownAdd = false;
  function toast(html) { live.innerHTML = html; live.classList.add('is-on'); clearTimeout(hideT); hideT = setTimeout(function () { live.classList.remove('is-on'); }, 4000); }
  function setCount(n) {
    if (typeof n !== 'number') return;
    document.querySelectorAll('.srs-badge').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.srs-ibtn[aria-label^="Cart"]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  function refreshCount() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; }); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('srs-card__form') || !window.fetch) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
    ownAdd = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) { return refreshCount().then(function () { toast('<b>Added to cart</b><span>' + (item.product_title || '') + '</span><a href="' + root + 'cart">View cart</a>'); }); })
      .catch(function (err) { toast('<b>Couldn\u2019t add this part</b><span>' + ((err && err.description) || 'Please try again or call us.') + '</span>'); })
      .finally(function () { ownAdd = false; if (btn) { btn.disabled = false; btn.textContent = label; } });
  });
  document.addEventListener('cart:update', function (e) {
    if (ownAdd) return;
    var d = (e && e.detail) || {};
    var res = d.resource || (d.data && d.data.cart) || null;
    var p = res && typeof res.item_count === 'number' ? Promise.resolve(res).then(function (c) { setCount(c.item_count); }) : refreshCount();
    p.then(function () { if (d.data && d.data.didError) return; if (!/\/cart(\/|$)/.test(location.pathname)) toast('<b>Added to cart</b><a href="' + root + 'cart">View cart</a>'); }).catch(function () {});
  });
})();
